<template>
  <div>
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  data(){
    return {
      msg: '404 页面'
    }
  }
}
</script>

<style>

</style>





// WEBPACK FOOTER //
// src/views/noFind/404.vue?cccbedda